import React from 'react';
import Rating from 'atomic/rating';
import Price from 'atomic/price';
import Icon from 'atomic/icon';
import Link from 'atomic/link';
import { ProductSimilarPricePropsInterface } from 'modules/product/interfaces/product-similar-price-props.interface';

import './product-comparison-desktop-item.scss';

interface ProductComparisonItemProps {
    products: ProductSimilarPricePropsInterface['products'];
}

const ProductComparisonDesktopItem: React.FC<ProductComparisonItemProps> = ({ products }) => {
    return (
        <div className="comparison-products-d">
            {products.map((item, idx) =>
                (
                    <div className="comparison-products-d__item" key={item.id}>
                        <div className="comparison-products-d__item__image">
                            <img
                                src={item.photo}
                                alt={item.name}
                                title={item.name}
                                width={164}
                                height={164}
                                loading="lazy"
                            />
                        </div>
                        <div className="comparison-products-d__item__name">
                            {item.name}
                        </div>
                        <div className="comparison-products-d__item__stars">
                            <Rating size="sm" opinions={item.opinions} />
                        </div>
                        <div className="comparison-products-d__item__price">
                            <span>od</span>
                            <Price price={item.price} weight={600} />
                        </div>
                        {idx === 0 && (
                            <Link
                                type="button"
                                color="light-blue"
                                href={item.url}
                                title={item.name}
                                size="md"
                                target="_blank"
                                rel="nofollow"
                                className="comparison-products-d__item__cta"
                            >
                                <Icon name="eye" color="secondary" size={20} />
                                Oglądany
                            </Link>
                        )}
                        {idx !== 0 && (
                            <Link
                                type="button"
                                color="secondary"
                                href={item.url}
                                title={item.name}
                                size="md"
                                target="_blank"
                                rel="nofollow"
                                className="comparison-products-d__item__cta"
                            >
                                Sprawdź
                            </Link>
                        )}
                    </div>
                )
            )}
        </div>
    );
};

export default ProductComparisonDesktopItem;
